import { z } from 'zod';

export type Thresholds = z.output<typeof thresholdsSchema>;
export type ThresholdsDTO = z.input<typeof thresholdsSchema>;

export const thresholdsSchema = z.object({
  shotLoadHigh: z.number().catch(3.5),
  shotLoadLow: z.number().catch(2),
});
